export const FEEDBACK_TYPEFORM_URL = 'https://shinetools.typeform.com/to/avc9AnSG#product_source=webapp'
